import { call, put, takeLatest, all } from 'redux-saga/effects';

import api from '../../api/api';
import { GET_ASSIGNEES_REQUEST, GET_ASSIGNEES_INFINITE_REQUEST } from './filterPanelActionTypes';
import {
  fetchAssigneesSuccess,
  fetchAssigneesFailure,
  fetchAssigneesInfiniteSuccess,
  fetchAssigneesInfiniteFailure
} from './filterPanelActions';


export function* fetchAssignees(action: any) {
  try {
    const { queryParams } = action;
    const users = yield call(api.user.fetchUsers, {
      ...queryParams,
      nextCursor: null
    });
    const remappedUsers = worklistUsers(users)
    yield put(fetchAssigneesSuccess(remappedUsers));
  } catch (err) {
    yield put(fetchAssigneesFailure(err));
  }
}

export function* fetchAssigneesInfinite(action: any) {
  try {
    const { queryParams } = action;
    queryParams.nextCursor += 20;
    const users = yield call(api.user.fetchUsers, queryParams);
    const remappedUsers = worklistUsers(users)
    yield put(fetchAssigneesInfiniteSuccess(remappedUsers));
  } catch (err) {
    yield put(fetchAssigneesInfiniteFailure(err));
  }
}

const worklistUsers = (users: any) => {
  // Coerce new endpoint to match old data structure
  const userItems = users.results.map((user: any, idx: any) => {
    return { displayName: user, id: user };
  });

  return {
    totalItems: users.totalItems,
    nextCursor: users.offset,
    items: userItems
  };
};

export default function* rootSaga() {
  yield all([takeLatest(GET_ASSIGNEES_REQUEST, fetchAssignees)]);
  yield all([takeLatest(GET_ASSIGNEES_INFINITE_REQUEST, fetchAssigneesInfinite)]);
}
